"use strict";

var _jsxRuntime = require("react/jsx-runtime");
module.exports = ({
  title,
  titleId,
  size,
  color,
  ...props
}) => /*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", {
  ...props,
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  height: size,
  width: size,
  fill: color,
  role: title ? 'img' : undefined,
  "aria-hidden": !title,
  "aria-labelledby": titleId,
  children: [title ? /*#__PURE__*/(0, _jsxRuntime.jsx)("title", {
    id: titleId,
    children: title
  }) : null, /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    fillRule: "evenodd",
    d: "M18.68.105c1.143 0 2.073.93 2.073 2.072v20.24c0 .601-.344 1.121-.897 1.357a1.448 1.448 0 0 1-1.592-.289l-5.524-5.257a1.064 1.064 0 0 0-1.478-.002l-5.527 5.261a1.459 1.459 0 0 1-1.596.286 1.457 1.457 0 0 1-.892-1.356V2.177c0-1.142.929-2.072 2.072-2.072H18.68Zm0 1H5.32c-.591 0-1.072.481-1.072 1.072v20.24c0 .291.219.408.287.437l.067.023a.452.452 0 0 0 .445-.116l5.525-5.258a2.063 2.063 0 0 1 2.86.002l5.524 5.257c.208.2.443.12.508.092l.074-.04a.456.456 0 0 0 .216-.397V2.177c0-.591-.481-1.072-1.072-1.072ZM12 2.597a.5.5 0 0 1 .453.287l1.544 3.288 3.446.526a.499.499 0 0 1 .284.843l-2.504 2.57.595 3.633a.497.497 0 0 1-.734.52L12 12.564l-3.075 1.698a.502.502 0 0 1-.736-.519l.597-3.633-2.504-2.57a.499.499 0 0 1 .282-.843l3.446-.526 1.537-3.287a.5.5 0 0 1 .371-.281L12 2.597Zm.001 1.678-1.198 2.563a.501.501 0 0 1-.378.282l-2.749.42 2.002 2.054a.498.498 0 0 1 .135.43l-.47 2.866 2.415-1.334a.507.507 0 0 1 .483 0l2.424 1.335-.47-2.867a.5.5 0 0 1 .135-.43l2.001-2.055-2.748-.419a.498.498 0 0 1-.377-.282l-1.205-2.563Z",
    clipRule: "evenodd"
  })]
});